import { render, staticRenderFns } from "./SPRPageSizeSelector.vue?vue&type=template&id=e245f264"
import script from "./SPRPageSizeSelector.vue?vue&type=script&lang=ts"
export * from "./SPRPageSizeSelector.vue?vue&type=script&lang=ts"
import style0 from "./SPRPageSizeSelector.vue?vue&type=style&index=0&id=e245f264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports